<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            title="Data Submitted"
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
      <b-container fluid>
        <h2 class="tw-mb-0 text-aegis-dk">IgG ELISA Processing</h2>
        <p class="tw-italic tw-text-gray-700">
          Blood sample processing
        </p>
      </b-container>
      <br />
  
      <!-- Show this row when page first loads -->
      <b-row v-if="blood_sample_id == ''">
        <b-col cols="3"></b-col>
        <b-col cols="4">
            <b-form-input
                v-model="aliquot_id"
                placeholder="Scan Aliquot Barcode"
                @keypress.enter="getIggElisa"
            ></b-form-input>
        </b-col>
        <b-col cols="2">
            <b-button
                @click="getIggElisa()"
                :disabled="aliquot_id == ''"
            >Submit</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <!-- Show this after we know which Blood Sample Analysis object we need -->
      <b-row v-else>
        <b-col cols="3"></b-col>
        <b-col cols="6">
            <b-row>
                <b-col><h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">IgG ELISA Processing for Blood Sample ID: {{ blood_sample_id }}</h1></b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Enter IgG Triplicate Value 1"
                        label="Enter IgG Triplicate Value 1"
                    >
                        <b-form-input
                            v-model="igg_triplicate_value_1"
                            placeholder="Enter IgG Triplicate Value 1"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Enter IgG Triplicate Value 2"
                        label="Enter IgG Triplicate Value 2"
                    >
                        <b-form-input
                            v-model="igg_triplicate_value_2"
                            placeholder="Enter IgG Triplicate Value 2"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-group
                        id="Enter IgG Triplicate Value 3"
                        label="Enter IgG Triplicate Value 3"
                    >
                        <b-form-input
                            v-model="igg_triplicate_value_3"
                            placeholder="Enter IgG Triplicate Value 3"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button
                class="mt-2"
                variant="success"
                size="lg"
                block
                @click="getIggElisa('update')"
                :disabled="processing_submit_disabled"
            >Submit Data</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
  import * as _ from "lodash";
  
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
            showModal: false,
            ModalMessage: 'Submitted successfully',
            blood_sample_id: '',
            blood_sample_analysis_id: '',
            aliquot_id: '',
            igg_triplicate_value_1: '',
            igg_triplicate_value_2: '',
            igg_triplicate_value_3: ''
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        let testing_fields = [
            this.igg_triplicate_value_1,
            this.igg_triplicate_value_2,
            this.igg_triplicate_value_3
        ]
        _.each(testing_fields, function(field) {
            if (field == null || field == '') {
                disabled = true;
            }
          });
        return disabled;
    }
},
watch: {},
created: function() {},
mounted: function() {},
methods: {
    getIggElisa: function(mode = null) {
        const that = this;
        const fd = new FormData();
        fd.append("aliquot_id", that.aliquot_id);
        
        if (mode) {
            fd.append("mode", mode);
            fd.append("igg_triplicate_value_1", that.igg_triplicate_value_1);
            fd.append("igg_triplicate_value_2", that.igg_triplicate_value_2);
            fd.append("igg_triplicate_value_3", that.igg_triplicate_value_3);
        }
        HTTP.post('srilanka/blood_sample/igg_elisa_processing/', fd).then((response) => {
            that.blood_sample_id = response.data.blood_sample_id;
            that.blood_sample_analysis_id = response.data.blood_sample_analysis_id;
            that.igg_triplicate_value_1 = response.data.igg_triplicate_value_1;
            that.igg_triplicate_value_2 = response.data.igg_triplicate_value_2;
            that.igg_triplicate_value_3 = response.data.igg_triplicate_value_3;
            if (mode == 'update') {
                this.ModalMessage = 'Submitted successfully';
                this.showModal = true;
            }
        }).catch((error) => {
            this.ModalMessage = 'There was a problem. Please check input values and try again.';
            this.showModal = true;
            HandleErrors.HandleErrors(error);
        });
    },
    clearFields() {
        this.blood_sample_id = '';
        this.blood_sample_analysis_id = '';
        this.aliquot_id = '';
        this.igg_triplicate_value_1 = '';
        this.igg_triplicate_value_2 = '';
        this.igg_triplicate_value_3 = '';
    }
}
};
</script>

<style scoped></style>
  